(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clothing-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-collection"]').forEach(initClothingCollection);
  });

  function initClothingCollection(root) {
    if (root.dataset.ccInit === 'true') return;
    root.dataset.ccInit = 'true';

    if (window.RfrInfiniteScroll) {
      window.RfrInfiniteScroll.init({
        root: root,
        gridSelector: '[data-product-grid]',
        itemSelector: '.cc-grid__item',
        paginationSelector: '.cc-pagination'
      });
    }

    var sectionId = root.dataset.sectionId;
    var scrim = root.querySelector('[data-panel-scrim]');

    function closeAllPanels() {
      root.querySelectorAll('[data-panel-body]').forEach(function (panel) {
        panel.classList.remove('is-open');
      });
      if (scrim) {
        scrim.classList.remove('is-open');
        scrim.hidden = true;
      }
    }

    function openPanel(name) {
      var panel = root.querySelector('[data-panel-body="' + name + '"]');
      if (!panel) return;
      closeAllPanels();
      panel.classList.add('is-open');
      if (window.matchMedia('(max-width: 900px)').matches && scrim) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
        });
      }
    }

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-panel-trigger]');
      if (trigger) {
        var name = trigger.dataset.panelTrigger;
        var panel = root.querySelector('[data-panel-body="' + name + '"]');
        if (panel && panel.classList.contains('is-open')) {
          closeAllPanels();
        } else {
          openPanel(name);
        }
        return;
      }

      if (e.target.closest('[data-panel-close]')) {
        closeAllPanels();
        return;
      }

      var clearBtn = e.target.closest('[data-clear-all]');
      if (clearBtn) {
        e.preventDefault();
        resetExtraFilters();
        fetchAndApply(root.dataset.collectionUrl);
        return;
      }

      var chip = e.target.closest('[data-filter-link]');
      if (chip) {
        e.preventDefault();
        fetchAndApply(chip.getAttribute('href'));
        return;
      }

      var midTabBtn = e.target.closest('[data-mid-tab]');
      if (midTabBtn) {
        var midFilter = midTabBtn.closest('[data-mid-filter]');
        if (midFilter) {
          var targetKind = midTabBtn.dataset.midTab;
          midFilter.querySelectorAll('[data-mid-tab]').forEach(function (btn) {
            var isTarget = btn === midTabBtn;
            btn.classList.toggle('is-active', isTarget);
            btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
          });
          midFilter.querySelectorAll('[data-mid-pane]').forEach(function (pane) {
            pane.hidden = pane.dataset.midPane !== targetKind;
          });
        }
        return;
      }

      var midApply = e.target.closest('[data-mid-filter-apply]');
      if (midApply) {
        var grid = root.querySelector('[data-product-grid]');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    });

    if (scrim) {
      scrim.addEventListener('click', closeAllPanels);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPanels();
    });

    document.addEventListener('click', function (e) {
      var sortWrap = root.querySelector('[data-panel-wrap="sort"]');
      var sortPanel = root.querySelector('[data-panel-body="sort"]');
      if (
        sortWrap &&
        sortPanel &&
        sortPanel.classList.contains('is-open') &&
        !sortWrap.contains(e.target) &&
        window.matchMedia('(min-width: 901px)').matches
      ) {
        closeAllPanels();
      }
    });

    var filterForm = root.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-filter-input]')) return;
        var params = new URLSearchParams(new FormData(filterForm));
        var sortInput = root.querySelector('[data-sort-input]:checked');
        if (sortInput) params.set('sort_by', sortInput.value);
        var url = root.dataset.collectionUrl + '?' + params.toString();
        fetchAndApply(url);
      });
    }

    root.querySelectorAll('[data-sort-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var params = new URLSearchParams(filterForm ? new FormData(filterForm) : '');
        params.set('sort_by', input.value);
        var url = root.dataset.collectionUrl + '?' + params.toString();
        fetchAndApply(url, function () {
          closeAllPanels();
        });
      });
    });

    function fetchAndApply(url, done) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          replacePart(doc, '[data-product-grid]');
          replacePart(doc, '[data-filter-form]');
          replacePart(doc, '[data-result-count]');
          replacePart(doc, '[data-filter-item-count]');
          replacePart(doc, '[data-filter-item-count-inline]');
          replaceAllQuickFilters(doc);

          var newClearButtons = doc.querySelectorAll('[data-clear-all]');
          root.querySelectorAll('[data-clear-all]').forEach(function (btn, i) {
            if (newClearButtons[i]) btn.hidden = newClearButtons[i].hidden;
          });

          var newDot = doc.querySelector('[data-filter-dot]');
          var dot = root.querySelector('[data-filter-dot]');
          if (dot && newDot) dot.hidden = newDot.hidden;

          // replacePart('[data-product-grid]') just wiped out the JS-
          // injected infinite-scroll sentinel along with the grid's old
          // contents (it lives inside the grid, right after .cc-pagination)
          // — re-init against the freshly-fetched pagination/grid so
          // scrolling still loads more of *this* filtered result set.
          if (window.RfrInfiniteScroll) {
            window.RfrInfiniteScroll.init({
              root: root,
              gridSelector: '[data-product-grid]',
              itemSelector: '.cc-grid__item',
              paginationSelector: '.cc-pagination'
            });
          }

          history.replaceState({}, '', url);

          // A native filter/sort change just replaced the grid with a fresh
          // (unfiltered-by-extras) page 1, and the dataset any active extra
          // filter was matching against is now stale — drop the cache and,
          // if extra filters are still checked, re-fetch/re-apply them
          // against the new native filter state. Otherwise just remember
          // this as the new "restore to" snapshot.
          invalidateExtraDataset();
          if (extraHasActive()) {
            applyExtraFilters();
          } else {
            captureOriginalGrid();
          }

          if (typeof done === 'function') done();
        })
        .catch(function (err) {
          console.error('Clothing collection filter/sort request failed:', err);
        });
    }

    function replacePart(doc, selector) {
      var current = root.querySelector(selector);
      var next = doc.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    }

    // There are now several independent quick-filter rows on the page
    // (toolbar style band, toolbar age band, mid-grid "Filters for you"
    // style/age bands), each tagged data-quick-filter="<kind>". Replace
    // each by its own kind so a filter/sort AJAX refresh keeps every row's
    // active-chip state in sync, not just the first one in DOM order.
    function replaceAllQuickFilters(doc) {
      root.querySelectorAll('[data-quick-filter]').forEach(function (el) {
        var kind = el.getAttribute('data-quick-filter') || '';
        var next = doc.querySelector('[data-quick-filter="' + kind + '"]');
        if (next) el.innerHTML = next.innerHTML;
      });
    }

    /* ---------- extra filters (client-side, beyond Search & Discovery's facet cap) ----------
       Each block under [data-extra-filters] is one facet backed by a
       product metafield (e.g. shopify.neckline) rather than a Search &
       Discovery filter, so there's no limit on how many a merchant adds.
       Because there's no server-side index for these, multi-select (OR
       within a facet, AND across facets) can't be resolved with a server
       round trip the way native filters are — so once any of these is
       checked, we pull every page of the *current* native filter/sort
       result (capped at EXTRA_MAX_PAGES pages) via the same section-render
       fetch already used for pagination, read each card's metafield values
       off its data-cc-facets attribute, and do the OR/AND matching here. */
    var extraFiltersEl = root.querySelector('[data-extra-filters]');
    var EXTRA_MAX_PAGES = 25;
    var extraActive = {};
    var extraCacheKey = null;
    var extraCacheItems = null;
    var extraOriginalGridHTML = null;
    var extraLoadToken = 0;

    function extraGetActiveGroups() {
      return Object.keys(extraActive).filter(function (g) {
        return extraActive[g] && extraActive[g].size > 0;
      });
    }

    function extraHasActive() {
      return extraFiltersEl ? extraGetActiveGroups().length > 0 : false;
    }

    function captureOriginalGrid() {
      if (!extraFiltersEl) return;
      var grid = root.querySelector('[data-product-grid]');
      if (grid) extraOriginalGridHTML = grid.innerHTML;
    }

    function invalidateExtraDataset() {
      extraCacheKey = null;
      extraCacheItems = null;
    }

    function resetExtraFilters() {
      if (!extraFiltersEl) return;
      extraActive = {};
      extraFiltersEl.querySelectorAll('[data-extra-filter-input]').forEach(function (input) {
        input.checked = false;
      });
      invalidateExtraDataset();
    }

    function restoreOriginalGrid() {
      var grid = root.querySelector('[data-product-grid]');
      if (grid && extraOriginalGridHTML !== null) {
        grid.innerHTML = extraOriginalGridHTML;
        if (window.RfrInfiniteScroll) {
          window.RfrInfiniteScroll.init({
            root: root,
            gridSelector: '[data-product-grid]',
            itemSelector: '.cc-grid__item',
            paginationSelector: '.cc-pagination'
          });
        }
      }
    }

    function extraDatasetKey() {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      return u.toString();
    }

    function loadExtraDataset(cb) {
      var key = extraDatasetKey();
      if (extraCacheKey === key && extraCacheItems) {
        cb(extraCacheItems);
        return;
      }

      var token = ++extraLoadToken;
      var items = [];

      function fetchPage(page) {
        var u = new URL(key);
        u.searchParams.set('page', page);
        u.searchParams.set('section_id', sectionId);
        fetch(u.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (token !== extraLoadToken) return; // superseded by a newer load
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nodes = doc.querySelectorAll('[data-product-grid] .cc-grid__item[data-cc-facets]');
            if (!nodes.length) {
              finish();
              return;
            }
            nodes.forEach(function (node) {
              var facets = {};
              try {
                facets = JSON.parse(node.getAttribute('data-cc-facets') || '{}');
              } catch (err) {
                facets = {};
              }
              items.push({ facets: facets, html: node.outerHTML });
            });
            if (page >= EXTRA_MAX_PAGES) {
              finish();
              return;
            }
            fetchPage(page + 1);
          })
          .catch(function (err) {
            console.error('Clothing collection extra-filter dataset fetch failed:', err);
            finish();
          });
      }

      function finish() {
        if (token !== extraLoadToken) return;
        extraCacheKey = key;
        extraCacheItems = items;
        cb(items);
      }

      fetchPage(1);
    }

    function renderExtraFiltered(items) {
      var grid = root.querySelector('[data-product-grid]');
      if (!grid) return;
      var groups = extraGetActiveGroups();

      var matches = items.filter(function (item) {
        return groups.every(function (g) {
          var wanted = extraActive[g];
          var have = item.facets[g] || [];
          return have.some(function (v) { return wanted.has(v); });
        });
      });

      if (!matches.length) {
        grid.innerHTML =
          '<div class="cc-empty" data-empty-state>' +
          '<p>Nothing matches that combination yet.</p>' +
          '<button type="button" class="cc-empty__clear" data-clear-all>Clear filters</button>' +
          '</div>';
        return;
      }

      grid.innerHTML = matches.map(function (m) { return m.html; }).join('');
    }

    function applyExtraFilters() {
      if (!extraHasActive()) {
        restoreOriginalGrid();
        return;
      }
      loadExtraDataset(renderExtraFiltered);
    }

    if (extraFiltersEl) {
      captureOriginalGrid();

      extraFiltersEl.addEventListener('change', function (e) {
        if (!e.target.matches('[data-extra-filter-input]')) return;
        var group = e.target.dataset.extraFilterGroup;
        var value = e.target.value;
        if (!extraActive[group]) extraActive[group] = new Set();
        if (e.target.checked) {
          extraActive[group].add(value);
        } else {
          extraActive[group].delete(value);
        }
        applyExtraFilters();
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-hero').forEach(initClothingHero);
  });

  function initClothingHero(root) {
    var track = root.querySelector('[data-hero-track]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var slides = track ? track.querySelectorAll('.cl-hero__slide') : [];
    if (!track || slides.length < 2) return;

    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      var slide = slides[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.heroDot, 10));
        restart();
      });
    });

    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    });

    function tick() {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      var next = (index + 1) % slides.length;
      goTo(next);
    }

    function start() {
      if (!autoplay || reduceMotion) return;
      timer = setInterval(tick, speed);
    }

    function restart() {
      clearInterval(timer);
      start();
    }

    track.addEventListener('pointerdown', function () {
      clearInterval(timer);
    });
    track.addEventListener('pointerup', restart);

    start();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-landing-quiz"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-quiz').forEach(initClothingQuiz);
  });

  function initClothingQuiz(root) {
    var answers = {};
    var steps = root.querySelectorAll('[data-quiz-step]');
    var segs = root.querySelectorAll('[data-quiz-seg]');
    var result = root.querySelector('[data-quiz-result]');
    var body = root.querySelector('.cl-quiz__body');

    var rules = [];
    var rulesScript = root.querySelector('[data-quiz-rules]');
    if (rulesScript) {
      try {
        rules = JSON.parse(rulesScript.textContent);
      } catch (e) {
        rules = [];
      }
    }

    function showStep(index) {
      steps.forEach(function (step) {
        step.classList.toggle('is-active', parseInt(step.dataset.quizStep, 10) === index);
      });
      segs.forEach(function (seg) {
        var segIndex = parseInt(seg.dataset.quizSeg, 10);
        seg.classList.toggle('is-active', segIndex === index);
        seg.classList.toggle('is-done', segIndex < index);
      });
    }

    function computeFabric() {
      // Rules are pre-sorted by priority (ascending) at render time; first match wins.
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        var seasonOk = rule.season === 'any' || rule.season === answers.season;
        var needOk = rule.need === 'any' || rule.need === answers.need;
        if (seasonOk && needOk) return rule.fabric;
      }
      // Fallback if no rules metaobject data is present.
      if (answers.need === 'soft') return 'tender-soft-micro-modal';
      if (answers.need === 'air') return answers.season === 'cool' ? 'pointelle-knit' : 'crinkle-cotton-muslin';
      if (answers.need === 'wear') return 'pointelle-knit';
      return answers.season === 'warm' ? 'crinkle-cotton-muslin' : 'tender-soft-micro-modal';
    }

    function showResult() {
      var key = computeFabric();
      steps.forEach(function (step) {
        step.classList.remove('is-active');
      });
      if (body) body.querySelector('[data-quiz-bar]').hidden = true;
      root.querySelectorAll('[data-fabric-key]').forEach(function (card) {
        card.hidden = card.dataset.fabricKey !== key;
      });
      if (result) result.hidden = false;
    }

    root.addEventListener('click', function (e) {
      var option = e.target.closest('[data-question]');
      if (option) {
        answers[option.dataset.question] = option.dataset.value;
        var currentStep = option.closest('[data-quiz-step]');
        var currentIndex = parseInt(currentStep.dataset.quizStep, 10);
        currentStep.querySelectorAll('[data-question]').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        option.classList.add('is-selected');

        setTimeout(function () {
          if (currentIndex < steps.length - 1) {
            showStep(currentIndex + 1);
          } else {
            showResult();
          }
        }, 220);
        return;
      }

      if (e.target.closest('[data-quiz-reset]')) {
        answers = {};
        if (result) result.hidden = true;
        var bar = root.querySelector('[data-quiz-bar]');
        if (bar) bar.hidden = false;
        root.querySelectorAll('[data-question].is-selected').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        showStep(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp-related-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-pdp-related').forEach(initClothingRelatedRail);
  });

  function initClothingRelatedRail(root) {
    var rail = root.querySelector('[data-rail]');
    var prevBtn = root.querySelector('[data-rail-prev]');
    var nextBtn = root.querySelector('[data-rail-next]');
    var dotsWrap = root.querySelector('[data-rail-dots]');
    var items = root.querySelectorAll('[data-rail-item]');
    if (!rail || !items.length) return;

    function scrollDistance() {
      var first = items[0];
      return first ? first.getBoundingClientRect().width + 18 : 300;
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = rail.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        rail.scrollBy({ left: -scrollDistance(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        rail.scrollBy({ left: scrollDistance(), behavior: 'smooth' });
      });
    }

    if (dotsWrap) {
      var dotCount = Math.min(items.length, 6);
      for (var i = 0; i < dotCount; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cl-pdp-related__dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.addEventListener('click', function () {
            var target = items[index];
            if (target) rail.scrollTo({ left: target.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        })(i);
      }

      rail.addEventListener(
        'scroll',
        function () {
          var maxScroll = rail.scrollWidth - rail.clientWidth;
          if (maxScroll <= 0) return;
          var activeIndex = Math.round((rail.scrollLeft / maxScroll) * (dotCount - 1));
          dotsWrap.querySelectorAll('.cl-pdp-related__dot').forEach(function (d, idx) {
            d.classList.toggle('is-active', idx === activeIndex);
          });
        },
        { passive: true }
      );
    }

    rail.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cl-pdp-tabs').forEach(initClothingPdpTabs);
  });

  function initClothingPdpTabs(root) {
    var triggers = root.querySelectorAll('[data-tab-trigger]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    var barWrap = root.querySelector('[data-tabs-bar-wrap]');

    function setActive(name) {
      triggers.forEach(function (t) {
        var active = t.dataset.tabTrigger === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function scrollToPanel(name) {
      var panel = root.querySelector('[data-tab-panel="' + name + '"]');
      if (!panel) return;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(name);
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () { scrollToPanel(t.dataset.tabTrigger); });
    });

    document.addEventListener('clothing-pdp:open-tab', function (e) {
      scrollToPanel(e.detail.tab);
    });

    // Scrollspy: highlight the tab whose panel is currently most in view.
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(entry.target.dataset.tabPanel);
            }
          });
        },
        { rootMargin: '-20% 0px -60% 0px', threshold: 0.01 }
      );
      panels.forEach(function (panel) { observer.observe(panel); });
    }

    // Sticky shadow once the tab bar reaches the top of the viewport.
    if (barWrap) {
      var toggleStuck = function () {
        barWrap.classList.toggle('is-stuck', barWrap.getBoundingClientRect().top <= 0);
      };
      window.addEventListener('scroll', toggleStuck, { passive: true });
      toggleStuck();
    }

    root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.cl-pdp-faq__item').classList.toggle('is-open');
      });
    });

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothing-pdp"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(initClothingPdp);
  });

  function initClothingPdp(root) {
    if (root.dataset.pdpInit === 'true') return;
    root.dataset.pdpInit = 'true';

    initGallery(root);
    initStickyBar(root);
    initCartHelpers(root);
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    var stage = root.querySelector('[data-gallery-stage]');
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    var current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        // Skip when the thumbs row is hidden (mobile) — scrollIntoView on a
        // display:none element is a no-op, and would otherwise be pointless work.
        if (i === index && thumb.offsetParent !== null) {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.index, 10));
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.dataset.index, 10));
      });
    });

    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    root.querySelectorAll('[data-jump-to-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('clothing-pdp:open-tab', { detail: { tab: btn.dataset.jumpToTab } }));
      });
    });

    initSwipe(stage, function () { show(current - 1); }, function () { show(current + 1); });
    initZoom(root);
  }

  // Touch-swipe support for the main gallery stage (mobile).
  function initSwipe(stage, onPrev, onNext) {
    if (!stage) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
      swiped = false;
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!tracking || e.touches.length !== 1) return;
      var deltaX = e.touches[0].clientX - startX;
      var deltaY = e.touches[0].clientY - startY;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        swiped = true;
        e.preventDefault();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      if (!swiped) return;

      var deltaX = (e.changedTouches[0].clientX - startX);
      if (Math.abs(deltaX) > 40) {
        if (deltaX > 0) {
          onPrev();
        } else {
          onNext();
        }
      }

      // Suppress the ghost click that follows a touch drag so the zoom
      // lightbox doesn't open right after a swipe.
      e.preventDefault();
    });
  }

  function initZoom(root) {
    var triggers = root.querySelectorAll('[data-gallery-zoom-trigger]');
    var lightbox = root.querySelector('[data-gallery-lightbox]');
    if (!triggers.length || !lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-img]');
    var spinner = lightbox.querySelector('[data-lightbox-spinner]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');

    var items = Array.prototype.map.call(triggers, function (trigger) {
      return {
        src: trigger.getAttribute('data-photoswipe-src'),
        alt: trigger.querySelector('img') ? trigger.querySelector('img').alt : ''
      };
    });

    var lightboxIndex = 0;

    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
      if (spinner) spinner.classList.remove('is-visible');
    });

    img.addEventListener('error', function () {
      if (spinner) spinner.classList.remove('is-visible');
    });

    function renderLightbox() {
      var item = items[lightboxIndex];
      if (!item) return;

      if (img.src === item.src && img.complete) {
        // Already loaded (e.g. flipping back to a previously viewed image) —
        // the browser won't refire "load" for an unchanged src, so skip
        // straight to the loaded state instead of spinning forever.
        img.classList.add('is-loaded');
        if (spinner) spinner.classList.remove('is-visible');
        return;
      }

      img.classList.remove('is-loaded');
      if (spinner) spinner.classList.add('is-visible');
      img.src = item.src;
      img.alt = item.alt;
    }

    function openLightbox(index) {
      lightboxIndex = index;
      renderLightbox();
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function lightboxPrev() {
      lightboxIndex = lightboxIndex <= 0 ? items.length - 1 : lightboxIndex - 1;
      renderLightbox();
    }

    function lightboxNext() {
      lightboxIndex = lightboxIndex >= items.length - 1 ? 0 : lightboxIndex + 1;
      renderLightbox();
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', lightboxPrev);
    if (nextBtn) nextBtn.addEventListener('click', lightboxNext);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxPrev();
      if (e.key === 'ArrowRight') lightboxNext();
    });

    initSwipe(lightbox, lightboxPrev, lightboxNext);
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-sticky-bar]');
    var anchor = root.querySelector('[data-atc-trigger]') || root.querySelector('.cl-pdp__gallery');
    if (!bar || !anchor) return;

    var stickyVariantTitle = root.querySelector('[data-sticky-variant-title]');
    if (stickyVariantTitle) {
      root.addEventListener('clothing-pdp:variant-change', function (e) {
        var variant = e.detail.variant;
        if (variant) stickyVariantTitle.textContent = variant.title;
      });
    }

    function updateVisibility() {
      if (window.matchMedia('(max-width: 900px)').matches) {
        bar.classList.add('on');
        return;
      }
      var rect = anchor.getBoundingClientRect();
      bar.classList.toggle('on', rect.bottom < 0);
    }

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.matchMedia('(max-width: 900px)').matches) {
            bar.classList.add('on');
            return;
          }
          bar.classList.toggle('on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      });
      observer.observe(anchor);
    } else {
      window.addEventListener('scroll', updateVisibility, { passive: true });
    }
    updateVisibility();

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-atc]')) {
        if (root.dataset.sizeRequired === 'true' && root.dataset.sizeSelected !== 'true') {
          if (window.clothingPdpOpenSizeSheet) window.clothingPdpOpenSizeSheet(root);
          return;
        }
        var mainAtc = root.querySelector('[data-atc-trigger]');
        if (mainAtc) mainAtc.click();
      }
    });
  }
  
  function clothingPdpAddToCartAjax(root, items) {
    var rootPath = root.dataset.rootUrl || '/';
    // Must be the .js (AJAX) endpoint — routes.cart_add_url ("/cart/add") returns
    // a redirect/HTML response, which breaks response.json() below and silently
    // aborts before the cart:open event fires, so the side drawer never opens
    // (even though the item is still added to the cart server-side).
    var cartAddUrl = (root.dataset.cartAddUrl || rootPath + 'cart/add').replace(/(\.js)?$/, '.js');
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to add items to cart.');
        return response.json();
      })
      .then(function (data) {
        return fetch(rootPath + 'cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cb').forEach(function (b) {
              if (cart.item_count > 0) {
                b.textContent = cart.item_count;
                b.style.display = 'flex';
              } else {
                b.style.display = 'none';
              }
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

            // The theme's actual cart drawer listens via jQuery events
            // (see biomimic-pdp.liquid's addToCartAjax) — without this,
            // the native CustomEvents above are dispatched but nothing
            // picks them up, so the drawer never opens.
            if (window.jQuery) {
              window.jQuery(document).trigger('ajaxProduct:added', [data]);
              window.jQuery(document).trigger('cart:open');
              window.jQuery(document).trigger('cart:updated', [cart]);
            }

            if (window.theme && window.theme.CartDrawer) {
              try { new window.theme.CartDrawer(); } catch (e) {}
            }
            clothingPdpToast(root, 'Added to bag successfully!');
            return cart;
          });
      })
      .catch(function (err) {
        console.error('Clothing PDP add-to-cart error:', err);
        clothingPdpToast(root, 'Error adding product(s) to cart.');
      });
  }

  function clothingPdpToast(root, message) {
    var toast = document.querySelector('[data-clothing-pdp-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-clothing-pdp-toast', '');
      toast.className = 'cl-pdp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function clothingPdpFormatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return currency + ' ' + amount;
    }
  }

  function initCartHelpers(root) {
    window.clothingPdpAddToCartAjax = window.clothingPdpAddToCartAjax || clothingPdpAddToCartAjax;
    window.clothingPdpToast = window.clothingPdpToast || clothingPdpToast;
    window.clothingPdpFormatMoney = window.clothingPdpFormatMoney || clothingPdpFormatMoney;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfr-fabric-test-reports"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var root = document.getElementById('rfr-test-reports');
    if(!root) return;

    /* ---------- banner carousel ---------- */
    var bnEl = root.querySelector('[data-banner]');
    if(bnEl){
      var track = bnEl.querySelector('[data-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      var dots = bnEl.querySelectorAll('[data-bndot]');
      var autoplay = parseInt(bnEl.dataset.autoplay, 10) || 0;
      var i = 0, timer = null;

      function go(n){
        if(!slides.length) return;
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        for(var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
      }
      function play(){
        if(!autoplay || slides.length < 2) return;
        stop();
        timer = setInterval(function(){ go(i + 1); }, autoplay);
      }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }

      if(slides.length > 1){
        bnEl.addEventListener('click', function(e){
          var nav = e.target.closest('[data-bn]');
          if(nav){ e.preventDefault(); go(i + (+nav.dataset.bn)); play(); return; }
          var dot = e.target.closest('[data-bndot]');
          if(dot){ go(+dot.dataset.bndot); play(); }
        });
        bnEl.addEventListener('mouseenter', stop);
        bnEl.addEventListener('mouseleave', play);
        bnEl.addEventListener('focusin', stop);

        var x0 = null;
        bnEl.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; stop(); }, {passive:true});
        bnEl.addEventListener('touchend', function(e){
          if(x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if(Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
          x0 = null; play();
        }, {passive:true});

        play();
      }
    }

    /* ---------- accordion ---------- */
    var accEl = root.querySelector('[data-acc]');
    var toggleAll = root.querySelector('[data-toggle-all]');

    accEl.addEventListener('click', function(e){
      var btn = e.target.closest('.rfr-fab__btn');
      if(!btn) return;
      var fab = btn.closest('.rfr-fab');
      var open = fab.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      syncToggleAll();
    });

    function syncToggleAll(){
      if(!toggleAll) return;
      var fabs = Array.prototype.slice.call(accEl.querySelectorAll('.rfr-fab'));
      var allOpen = fabs.length > 0 && fabs.every(function(f){ return f.classList.contains('is-open'); });
      toggleAll.textContent = allOpen ? 'Collapse all' : 'Expand all';
      toggleAll.dataset.state = allOpen ? 'open' : 'closed';
    }

    if(toggleAll){
      toggleAll.addEventListener('click', function(){
        var open = toggleAll.dataset.state !== 'open';
        accEl.querySelectorAll('.rfr-fab').forEach(function(fab){
          fab.classList.toggle('is-open', open);
          fab.querySelector('.rfr-fab__btn').setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        syncToggleAll();
      });
    }

    syncToggleAll();

    /* ---------- style detail drawer ---------- */
    var drawer = root.querySelector('[data-drawer]');
    var drawerB = root.querySelector('[data-drawer-body]');
    var lastFocus = null;

    function openDrawer(card){
      var tpl = card.parentElement.querySelector('[data-drawer-tpl]');
      if(!tpl || !drawer || !drawerB) return;
      drawerB.innerHTML = '';
      drawerB.appendChild(tpl.content.cloneNode(true));
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = drawer.querySelector('.rfr-drawer__x');
      if(x) x.focus();
    }
    function closeDrawer(){
      if(!drawer) return;
      drawer.hidden = true;
      document.body.style.overflow = '';
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }

    accEl.addEventListener('click', function(e){
      var card = e.target.closest('[data-drawer-open]');
      if(card) openDrawer(card);
    });
    if(drawer){
      drawer.querySelectorAll('[data-drawer-close]').forEach(function(el){
        el.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && !drawer.hidden) closeDrawer();
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfr-media-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE = window.matchMedia('(max-width: 749px)');
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function saveData() {
      var c = navigator.connection;
      return !!(c && c.saveData);
    }

    function MediaSlider(root) {
      if (root.__msInit) return;
      root.__msInit = true;

      var track = root.querySelector('.ms-slider__track');
      var prev = root.querySelector('.ms-slider__nav--prev');
      var next = root.querySelector('.ms-slider__nav--next');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.ms-card--video'));
      var autoplayMobile = root.getAttribute('data-autoplay-mobile') === 'true';
      var inView = true;
      var scrollTimer;

      /* ---------- arrows ---------- */
      function updateNav() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      }

      function scrollByPage(dir) {
        track.scrollBy({
          left: dir * track.clientWidth * 0.85,
          behavior: REDUCED.matches ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { scrollByPage(1); });

      /* ---------- video ---------- */
      function play(card) {
        var video = card.querySelector('.ms-card__video');
        if (!video) return;
        if (!video.getAttribute('src')) {
          // Lazy: the file is only requested the first time it's played.
          video.src = video.getAttribute('data-src');
          video.preload = 'auto';
          card.classList.add('is-loading');
          video.load();
        }
        var p = video.play();
        if (p && p.catch) p.catch(function () { card.classList.remove('is-loading'); });
      }

      function pause(card) {
        var video = card.querySelector('.ms-card__video');
        if (video && !video.paused) video.pause();
      }

      cards.forEach(function (card) {
        var video = card.querySelector('.ms-card__video');
        var btn = card.querySelector('.ms-card__btn');

        video.addEventListener('playing', function () {
          card.classList.remove('is-loading');
          card.classList.add('is-playing', 'is-started');
          btn.setAttribute('aria-label', 'Pause video');
        });
        video.addEventListener('pause', function () {
          card.classList.remove('is-playing');
          btn.setAttribute('aria-label', 'Play video');
        });
        video.addEventListener('error', function () {
          card.classList.remove('is-loading');
        });

        btn.addEventListener('click', function () {
          if (video.paused) {
            card.__manualPause = false;
            // Only one video at a time.
            cards.forEach(function (c) { if (c !== card) pause(c); });
            play(card);
          } else {
            card.__manualPause = true;
            pause(card);
          }
        });

        card.addEventListener('touchstart', function () {
          card.classList.add('is-touch');
        }, { passive: true, once: true });
      });

      /* ---------- mobile: autoplay the centred slide ---------- */
      function centredCard() {
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
        var best = null;
        var bestDist = Infinity;
        Array.prototype.forEach.call(track.children, function (li) {
          var r = li.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestDist) { bestDist = d; best = li; }
        });
        return best;
      }

      function syncCentred() {
        if (!MOBILE.matches || !autoplayMobile) return;
        var centred = inView ? centredCard() : null;
        cards.forEach(function (card) {
          if (card === centred) {
            if (!card.__manualPause && !REDUCED.matches && !saveData()) play(card);
          } else {
            card.__manualPause = false; // a new visit to this slide autoplays again
            pause(card);
          }
        });
      }

      track.addEventListener('scroll', function () {
        updateNav();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncCentred, 120);
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (!inView) cards.forEach(pause);
          syncCentred();
        }, { threshold: 0.4 }).observe(root);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) cards.forEach(pause);
        else syncCentred();
      });

      if (MOBILE.addEventListener) {
        MOBILE.addEventListener('change', function () {
          cards.forEach(pause);
          syncCentred();
        });
      }

      window.addEventListener('resize', updateNav);
      updateNav();
      syncCentred();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.ms-slider').forEach(MediaSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
